<template>
    <div ref="containerRef" class="vkid-oauth-container">
        <!-- Контейнер для вставки VK ID кнопки -->
    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineProps, defineEmits } from 'vue'
import {Api} from "@/service/api";
import {SITE_URL} from "@/service/config";

const props = defineProps({
    appId: {
        type: Number,
        default: 54320016
    },
    scope: {
        type: String,
        default: 'vkid.personal_info email'
    },
    showAlternativeLogin: {
        type: Boolean,
        default: true
    }
})

const emit = defineEmits(['success', 'error'])

const containerRef = ref(null)
const oneTap = ref(null)

const vkidOnSuccess = async (data) => {
    console.log("VK_OAUTH_DATA", data)
    await Api.VKOauthLogin({
        access_token: data.access_token,
    })
    window.location.reload();
}

const vkidOnError = (error) => {
    emit('error', error)
}

const handleLoginSuccess = (payload) => {
    const { code, device_id: deviceId } = payload

    if (!window.VKIDSDK) {
        vkidOnError(new Error('VK ID SDK not available'))
        return
    }

    const VKID = window.VKIDSDK

    VKID.Auth.exchangeCode(code, deviceId)
        .then(vkidOnSuccess)
        .catch(vkidOnError)
}

const initVkId = () => {
    if (!window.VKIDSDK) {
        vkidOnError(new Error('VK ID SDK not available'))
        return
    }

    const VKID = window.VKIDSDK

    try {
        // Инициализация конфигурации
        VKID.Config.init({
            app: props.appId,
            redirectUrl: SITE_URL,
            responseMode: VKID.ConfigResponseMode.Callback,
            source: VKID.ConfigSource.LOWCODE,
            scope: props.scope,
        })

        // Создание виджета OneTap
        oneTap.value = new VKID.OneTap()

        // Рендеринг кнопки
        oneTap.value
            .render({
                container: containerRef.value,
                showAlternativeLogin: props.showAlternativeLogin
            })
            .on(VKID.WidgetEvents.ERROR, vkidOnError)
            .on(VKID.OneTapInternalEvents.LOGIN_SUCCESS, handleLoginSuccess)

    } catch (error) {
        vkidOnError(error)
    }
}

const loadVkIdScript = () => {
    // Проверяем, не загружен ли скрипт уже
    if (window.VKIDSDK) {
        initVkId()
        return
    }

    const script = document.createElement('script')
    script.src = 'https://unpkg.com/@vkid/sdk@<3.0.0/dist-sdk/umd/index.js'
    script.onload = () => {
        initVkId()
    }
    script.onerror = () => {
        vkidOnError(new Error('Failed to load VK ID SDK'))
    }

    document.head.appendChild(script)
}

const cleanup = () => {
    if (oneTap.value) {
        try {
            oneTap.value.destroy()
        } catch (error) {
            console.warn('Error cleaning up VK ID widget:', error)
        }
        oneTap.value = null
    }
}

onMounted(() => {
    loadVkIdScript()
})

onBeforeUnmount(() => {
    cleanup()
})
</script>

<style scoped>
.vkid-oauth-container {
    display: inline-block;
    min-height: 40px;
}
</style>